// export const ADVERTISEMENT_SLIDER        = 'advertisement-slider'
export const ADVERTISEMENT_MAIN_SLIDER      = 'main_slider'
export const ADVERTISEMENT_OVERVIEW_BANNER  = 'overview_banner'
export const ADVERTISEMENT_OVERVIEW_HERO    = 'overview_hero'
export const ADVERTISEMENT_INTERSCROLLER    = 'interscroller'
export const ADVERTISEMENT_FIREPLACE        = 'fireplace'
export const ADVERTISEMENT_HOME_BANNER      = 'home_banner'
